/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneArticle from 'base/components/standalone/Article';

export const DynamicStandaloneArticle = StandaloneArticle;
export type DynamicStandaloneArticleProps = PropsFromComponent<typeof StandaloneArticle>;

export const DynamicStandaloneArticleWith = (extras: DynamicStandaloneExtras): typeof StandaloneArticle => {
    return function DynamicStandaloneArticle(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Article');
        return <StandaloneArticle {...mergeProps({ options: { theme } }, props)} />;
    }
}